<template>
  <h1>Loading...</h1>
</template>

<script>
export default {
  props: {
    color: { default: 'primary', type: String },
    indeterminate: { default: true, type: Boolean },
    loading: { default: true, type: Boolean },
    size: { default: 60, type: [Number, String] },
  },
}
</script>
